<div class="section-wrapper">
  <vi-content-item [fluid]="true" [twoColumns]="true" leftColumnWidth="45%" rightColumnWidth="55%">
    <ng-container leftColumn>
      <h3>
        {{
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.ADDITIONAL_FEATURE_WITH_VIGUIDE_PRO.TITLE'
            | translate
        }}
      </h3>
      <div class="flex">
        <div>
          <ul>
            <li>
              {{
                '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.ADDITIONAL_FEATURE_WITH_VIGUIDE_PRO.DESCRIPTION1'
                  | translate
              }}
            </li>
            <li>
              {{
                '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.ADDITIONAL_FEATURE_WITH_VIGUIDE_PRO.DESCRIPTION2'
                  | translate
              }}
            </li>
            <li>
              {{
                '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.ADDITIONAL_FEATURE_WITH_VIGUIDE_PRO.DESCRIPTION3'
                  | translate
              }}
            </li>
          </ul>
          <button
            mat-raised-button
            gtm="onGoToPage"
            gtmAction="Booking"
            gtmCategory="internalHydraulic"
            [routerLink]="['/booking']"
            color="primary"
            class="mt-4 !h-fit view-booking-btn"
          >
            {{
              '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.ADDITIONAL_FEATURE_WITH_VIGUIDE_PRO.VIEW_PRO_FEATURES'
                | translate
            }}
          </button>
        </div>

        <div class="vertical-line"></div>
      </div>
    </ng-container>
    <ng-container rightColumn>
      <h3>
        {{
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.AUTOMATIC_MONITORING_WITH_PERMANENT_INSPECTION.TITLE'
            | translate
        }}
      </h3>
      <ul>
        <li>
          {{
            '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.AUTOMATIC_MONITORING_WITH_PERMANENT_INSPECTION.DESCRIPTION1'
              | translate
          }}
        </li>
        <li>
          {{
            '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.AUTOMATIC_MONITORING_WITH_PERMANENT_INSPECTION.DESCRIPTION2'
              | translate
          }}
        </li>
        <li>
          {{
            '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.AUTOMATIC_MONITORING_WITH_PERMANENT_INSPECTION.DESCRIPTION3'
              | translate
          }}
        </li>
      </ul>
      <p>
        {{
          '+INSTALLATIONS.INSTALLATION.INTERNAL_HYDRAULIC.AUTOMATIC_MONITORING_WITH_PERMANENT_INSPECTION.NOTE'
            | translate
        }}
      </p>
    </ng-container>
  </vi-content-item>
</div>
